import { createAction } from '@reduxjs/toolkit';
import { TLeftIsOpen,TRightIsOpen,TScrollChat } from '../../../typescript/redux/control/types'

const actionLeftIsOpen= createAction('control/LeftIsOpen', (value:TLeftIsOpen) => ({
  payload: value,
}));

const actionRightIsOpen= createAction('control/RightIsOpen', (value:TRightIsOpen) => ({
  payload: value,
}));

const actionScrollChat = createAction('control/scrollChat', (value:TScrollChat) => ({
  payload: value,
}));

const actionOpenPinned = createAction('control/openPinned', (value:boolean) => ({
  payload: value,
}));



export { actionLeftIsOpen,actionRightIsOpen,actionScrollChat,actionOpenPinned };
